<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-input v-model="searchName" placeholder="请输入试卷名称" />
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="search">搜索</el-button>
      </el-col>
    </el-row>

    <el-table
      ref="multipleTable"
      :data="tableData"
      row-key="examsPaperId"
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55"
      ></el-table-column>
      <el-table-column prop="examsPaperId" label="试卷ID"> </el-table-column>
      <el-table-column prop="examsPaperTitle" label="试卷名称">
      </el-table-column>
      <el-table-column label="板块">
        <div v-if="examType === 2">课时练习</div>
        <div v-if="examType === 3">课时测验</div>
        <div v-if="examType === 6">课时考试</div>
      </el-table-column>
      <el-table-column prop="title" label="难度"> </el-table-column>
      <el-table-column prop="questionsCount" label="试题数"> </el-table-column>
      <el-table-column prop="score" label="总分"> </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import * as api from '@/api/courseStructure/courseStructure'
export default {
  props: ['examType', 'courseWareId', 'zyVideoSectionId'],
  data() {
    return {
      searchName: '',
      tableData: [],
      pageObj: {
        page: 1,
        pageSize: 10,
      },
      total: 0,
    }
  },
  created() {
    this.getExamList()
  },
  watch: {
    examType(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.searchName = ''
        this.pageObj = { page: 1, pageSize: 10 }
        this.getExamList()
      }
    },
  },
  filters: {
    correctLevel(val) {
      if (val === 1) {
        return '简单'
      } else if (val === 2) {
        return '中等'
      } else if (val === 3) {
        return '困难'
      }
    },
  },
  methods: {
    search() {
      this.pageObj.page = 1
      this.getExamList()
    },
    async getExamList() {
      let type = ''
      if (this.examType === 2) {
        type = '-3'
      } else if (this.examType === 3) {
        type = '-2'
      } else if (this.examType === 6) {
        type = '-1'
      }
      const zyVideoSectionId = this.zyVideoSectionId || 1
      const courseWareId = this.courseWareId
      const { page, pageSize } = this.pageObj
      const data = (
        await api.getListByExams({
          type,
          zyVideoSectionId,
          courseWareId,
          page,
          pageSize,
          name: this.searchName,
        })
      ).data
      if (data.code === 100000) {
        this.tableData = data.data.list
        this.total = data.data.total
        const index = this.tableData.findIndex((item) => item.isCheck > 0)
        if (index > -1) {
          this.$refs.multipleTable.toggleRowSelection(
            this.tableData[index],
            true
          )
        }
      }
    },
    save() {
      const selectedList = this.$refs.multipleTable.selection
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else if (selectedList.length > 1) {
        return this.$message({ type: 'warning', message: '最多可选一份试卷' })
      } else {
        this.$parent.$parent.submitForm()
      }
    },
    appendChild(zyVideoSectionId) {
      const selectedList = this.$refs.multipleTable.selection
      api
        .addCourseStructure({
          zyVideoSectionId: zyVideoSectionId,
          eid: selectedList[0].examsPaperId,
        })
        .then(({ data }) => {
          if (data.code == 100000) {
            this.$emit('endSave')
            this.$message({ type: 'success', message: data.msg })
          } else {
            this.$message({ type: 'error', message: data.msg })
          }
        })
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getExamList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getExamList()
    },
  },
}
</script>

<style>
</style>